import { Extension } from "@tiptap/core";
import Suggestion, { type SuggestionOptions } from "@tiptap/suggestion";
import { PluginKey } from "@tiptap/pm/state";

export const MentionPluginKey = new PluginKey("mentionSuggestion");

export default Extension.create({
  name: "mentionCommand",

  addOptions(): { suggestion: Partial<SuggestionOptions> } {
    return {
      suggestion: {
        char: "@",
        command: ({ editor, range, props }) => {
          editor
            .chain()
            .focus()
            .deleteRange(range)
            .insertContent({
              type: "memberInlineBlock",
              attrs: { user: props.result },
            })
            .run();
        },
      },
    };
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        pluginKey: MentionPluginKey,
        editor: this.editor,
        ...this.options.suggestion,
        // don't show for titles
        allow: ({ editor }) => !editor.isActive("title"),
      }),
    ];
  },
});
